"use client";

import React from "react";

import ImageAtom, { MagnoliaImage } from "@/components/atoms/image/image";
import Logo from "@/components/molecules/logo-component/logo";
import Styles from "@/components/molecules/policy-document-section/policy-document-section.module.css";
import withBrand from "@/components/with-brand";

interface WithdrawalImageProps {
  withdrawalBannerImage: {
    "@name": string;
    "@path": string;
    "@id": string;
    "@link": string;
    "@type": string;
    "@uuid": string;
  } | null;
  brand?: string;
}

function WithdrawalImageContent({
  withdrawalBannerImage,
  brand,
}: Readonly<WithdrawalImageProps>) {
  const imageProps: MagnoliaImage | undefined | null =
    typeof withdrawalBannerImage === "string"
      ? {
          "@id": "",
          "@link": withdrawalBannerImage,
          "@name": "",
          "@path": "",
          "@type": "",
          "@uuid": "",
        }
      : withdrawalBannerImage;

  const srcImage = `${process.env.NEXT_PUBLIC_MGNL_HOST}/dam/${imageProps?.["@id"]}${imageProps?.["@path"]}`;

  return (
    <div
      className="flex flex-col gap-spacing-m md:gap-spacing-l"
      data-testid="withdrawal-imageBanner-testid"
    >
      {imageProps && (
        <>
          {/* Desktop image */}
          <div className="hidden lg:block">
            <ImageAtom
              image={imageProps}
              altText="Withdrawal Verification Banner"
              styleClass={`rounded-xl absolute inset-0 w-full ${brand} ${Styles.coverImageBannerHeight} object-cover object-center`}
              data-testid="withdrawal-banner-image-testid"
            />
          </div>

          {/* Mobile/Tablet image */}
          <div
            style={{
              backgroundImage: `url(${srcImage})`,
              backgroundRepeat: "no-repeat",
              zIndex: 1,
            }}
            className="flex lg:flex-col ml-[50%] !bg-cover flex-col-reverse lg:!bg-center !bg-right rounded-xl h-[88px] md:h-[175px] lg:hidden"
          />
        </>
      )}
      <div
        className={`absolute inset-0 lg:hidden block z-10 ${brand} ${Styles.coverImageBanner}`}
      >
        <div className="absolute inset-0 flex items-center lg:hidden z-10">
          <Logo
            color="primary"
            size="xl"
            className={`${brand} ${Styles.logo}`}
          />
        </div>
      </div>
    </div>
  );
}

export default withBrand(WithdrawalImageContent);
